export const portfolioData = [
  {
    id: 4,
    title: 'Catálogo de Escoltas y Citas',
    category: 'SaaS',
    description: 'Plataforma web integral tipo SaaS diseñada para la gestión operativa y comercial de personal de seguridad. Ofrece un catálogo interactivo público y un panel de administración avanzado con control de roles, autenticación segura y generación de expedientes PDF.',
    technologies: ['MERN Stack', 'MongoDB', 'Express.js', 'React', 'JWT Auth'],
    image: '/img/portfolio/cat-escoltas.png',
    link: '#',
  },
  {
    id: 3,
    title: 'Mobile Homes Capital',
    category: 'Bienes Raices',
    description: 'Aplicación web premium enfocada al sector de la construcción y bienes raíces. Desarrollada con arquitectura modular y equipada con un sistema bilingüe inteligente (Español/Inglés) que detecta automáticamente el idioma del usuario para ofrecer una experiencia internacional fluida.',
    technologies: ['React', 'CSS Modules', 'i18n (Multi-idioma)', 'Swiper'],
    image: '/img/portfolio/mhomecapital.png',
    link: 'http://www.mhomescapital.com',
  },
  {
    id: 2,
    title: 'MF Capital - Grupo Corporativo',
    category: 'Corporativo',
    description: 'Plataforma web corporativa premium con diseño dark mode, efecto glassmorphism y acentos dorados. Incluye un sistema de enrutamiento dinámico para los portafolios de sus filiales y un sistema de contacto integrado con protección anti-spam.',
    technologies: ['React', 'Vite', 'EmailJS', 'Vanilla CSS'],
    image: '/img/portfolio/mfcapital.png',
    link: 'https://www.mfcapital.mx',
  },
  {
    id: 1,
    title: 'Proyecto Cam360 - Renta de Cabinas',
    category: 'Landing Page',
    description: 'Sitio web moderno y responsivo para empresa especializada en renta de cabinas 360° en CDMX. Destaca por su carrusel interactivo, animaciones sutiles, rutas optimizadas y una integración directa para cotizaciones por WhatsApp.',
    technologies: ['React', 'CSS Modules', 'Mobile-First', 'WhatsApp API'],
    image: '/img/portfolio/procam360.png',
    link: 'https://www.procam360.mx',
  }
];

export const portfolioCategories = ['Todos', 'E-Commerce', 'SaaS', 'Corporativo', 'Landing Page', 'Bienes Raices'];
